import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

type SoftwareVersionsResponse = {
  versions: string[]
}

const SOFTWARE_VERSIONS_LIST_KEY = 'softwareVersionsByProgram'

export const useGetSoftwareVersions = (programId?: string) => {
  return useQuery({
    queryKey: [SOFTWARE_VERSIONS_LIST_KEY, programId],
    queryFn: async () => {
      const { data } = await apiClient.get<SoftwareVersionsResponse>(
        `/int/v3/programs/${programId}/software-versions`
      )

      return data.versions
    },
    enabled: Boolean(programId),
  })
}
